(function (global, factory) {
    'use strict';
    if (typeof define === 'function' && define.amd) {
        define(['jquery'], function ($) {
            return factory($, global, global.document);
        });
    } else if (typeof exports === "object" && exports) {
        module.exports = factory(require('jquery'), global, global.document);
    } else {
        factory(jQuery, global, global.document);
    }
})(typeof window !== 'undefined' ? window : this, function ($, window, document, undefined) {
    'use strict';

    const pluginName = 'productsSlider';
    const defaultOptions = {};
    const $window = $(window);
    const $document = $(document);

    const p = {};
    p[pluginName] = class {

        _panelStep = 0;
        _buttons = {};
        _drag = {
            delta: 0,
            mouseStartPosition: 0
        };

        constructor(el, opts) {
            this.el = el;
            this.opts = $.extend({}, defaultOptions, opts);
            this._defaultOptions = defaultOptions;
            this._buttons = {
                prev: $('.products-prev', this.el),
                next: $('.products-next', this.el)
            }
            this._productsCount= $('.product', this.el).length;
            this._panel = $('.products-slide-panel', this.el);

            this.addEventListeners();
        }

        init() {
            this._panelWidth = this._panel.width();
            this._currentPosition = 0;
            this._displayProducts = 0;

            this._panel.addClass('dragging').css('left', 0).removeClass('dragging');
            this.getVisibleProductsCount();
            this.setButtonsVisibility();
        }

        addEventListeners() {

            // Observe the container size changes
            let observer = new ResizeObserver(() => {
                this.init();
            });
            observer.observe(this.el);

            // Add prev / next buttons actions
            this._buttons.next.on('click', () => {
                this.next();
            });

            this._buttons.prev.on('click', () => {
                this.prev();
            });

            // Add touch events
            this._panel.on('touchstart', (e) => {
                this._panel.addClass('dragging');
                this._drag.delta = 0;
                this._drag.startPosition = e.touches ? e.touches[0].pageX : e.pageX;
                this._drag.panelStartPosition = this._panel.position().left;

                this._panel.off('touchmove');
                this._panel.on('touchmove', (e) => {
                    this._drag.delta = (e.touches ? e.touches[0].pageX : e.pageX) - this._drag.startPosition;
                    this._panel.css('left', (this._drag.panelStartPosition + this._drag.delta) + 'px');
                });

                this._panel.off('touchend');
                this._panel.on('touchend', (e) => {
                    this._panel.off('touchmove');
                    this._panel.removeClass('dragging');
                    this.getPositionByPanelOffset();
                });
            });
        }

        getPositionByPanelOffset() {
            // Get position (int) based on the panel offset position (px)
            let productWidth = $('.product').first().width();
            let newPosition = 0;
            if(this._drag.delta > 0) {
                // prev
                newPosition = Math.floor(-this._panel.position().left / productWidth);
            } else {
                // next
                newPosition = Math.ceil(-this._panel.position().left / productWidth);
            }

            if (newPosition < 0) {
                newPosition = 0;
            } else if (newPosition + this._displayProducts > this._productsCount) {
                newPosition = this._productsCount - this._displayProducts;
            }
            this.setPosition(newPosition);
        }

        getVisibleProductsCount() {
            // Get a number of visible products in the slider
            $('.product', this.el).each((index, product) => {
                this._displayProducts += product.offsetLeft < this._panelWidth ? 1 : 0;
            });
            this._panelStep = 100 / this._displayProducts;
        }

        next() {
            this.setPosition(this._currentPosition + 1);
        }

        prev() {
            this.setPosition(this._currentPosition - 1);
        }

        setButtonsVisibility() {
            this._currentPosition <= 0 ? this._buttons.prev.fadeOut() : this._buttons.prev.fadeIn();
            this._currentPosition + this._displayProducts >= this._productsCount ? this._buttons.next.fadeOut() : this._buttons.next.fadeIn();
        }


        setPosition(value) {
            // Set panel position based on a number of visible products
            if(this._displayProducts + value > this._productsCount || value < 0) {
                return;
            }

            this._currentPosition = value;
            this._panel.css('left', -(this._currentPosition * this._panelStep) + '%');
            this.setButtonsVisibility();
        }

    }

    $.fn[pluginName] = function (options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new p[pluginName](this, options));
            }
        });
    };
});
